import { Icon } from '@iconify/react';
import { useRef, useState, useCallback, useEffect } from 'react';
import peopleFill from '@iconify/icons-eva/people-fill';
import searchFill from '@iconify/icons-eva/search-fill';
// material
import { alpha } from '@material-ui/core/styles';
import { ListItemAvatar, Typography, ListItemText, Avatar, ListItemButton, Tooltip, IconButton, Stack, Box, Button, OutlinedInput, InputAdornment } from '@material-ui/core';
// hooks
import useIsMountedRef from '../../hooks/useIsMountedRef';
// utils
import axios from '../../helper/axiosIntance';
import { fToNow } from '../../utils/formatTime';
// components
import Scrollbar from '../../components/Scrollbar';
import MenuPopover from '../../components/MenuPopover';
import BadgeStatus from '../../components/BadgeStatus';
import { MIconButton } from '../../components/@material-extend';
import apiContact from '../../api/contact';
import flashFill from '@iconify/icons-eva/flash-fill';
import phoneCallFill from '@iconify/icons-eva/phone-call-fill';
import { useSelector } from '../../redux/store';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import FormActionContact2 from '../../pages/ActionContact/FormActionContact2';
import { styled } from '@material-ui/core/styles';
import { concat } from 'lodash';
import { List } from 'immutable';
import ListQuickContacts from './ListQuickContacts';
// ----------------------------------------------------------------------

const ITEM_HEIGHT = 64;
const PADDING_ITEM = 2.5;
const theme = createTheme({
  palette: {
    voip: {
      main: "#303187",
      contrastText: "#fff"
    },
  }
});
const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: "100%",
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter
  }),
  '&.Mui-focused': { width: "100%", boxShadow: theme.customShadows.z8 },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`
  }
}));
export default function ContactsPopover() {
  const scrollRef = useRef();
  const anchorRef = useRef(null);
  const isMountedRef = useIsMountedRef();
  const [open, setOpen] = useState(false);
  const [contacts, setContacts] = useState([]);
  const { doCall } = useSelector(state => state.janus)
  const [isShowAddContactOnSelect, setIsShowAddContactOnSelect] = useState(false);
  const [isRefreshContact, setIsRefreshContact] = useState(false);
  const [paramSearch, setParamSearch] = useState({});
  const [page, setPage] = useState(1);
  const [endPage, setEndPage] = useState(false);
  const [heightScroll, setHeightScroll] = useState(0);



  const load_contact = async () => {
    const res = await apiContact.view3({ paramSearch: paramSearch });
    setContacts(res.data.data);
    setEndPage(false);
    setPage(1);
  }
  const load_more_contact = async () => {
    if (!endPage) {
      const res = await apiContact.view3({ paramSearch: paramSearch, page });
      if (res.data.data.length == 0) {
        setEndPage(true);
      }
      setContacts(contacts.concat(res.data.data));
    }
  }

  const loadMoreContacts = async () => {
    if (!endPage) {
      setPage(page + 1);
    }
  }
  const getContacts = useCallback(async () => {
    try {
      const res = await apiContact.view3();
      setContacts(res.data.data);
    } catch (error) {
      console.error(error);
    }
  }, [isMountedRef]);
  useEffect(() => {
    getContacts();
  }, [getContacts]);
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const callContact = async (phoneNumber) => {
    const res_info = await apiContact.view({ phoneNumber: phoneNumber });
    setOpen(false);
    doCall(phoneNumber, res_info.data.data);
  }
  const handleAddContact = () => {
    setIsShowAddContactOnSelect(prev => !prev);
    handleClose();
  };
  const handleCloseAddContact = () => {
    setIsShowAddContactOnSelect(false);
  };

  const handleParamSearch = async (e) => {
    setParamSearch({ ...paramSearch, [e.target.name]: e.target.value });
  }
  useEffect(() => {
    load_contact();
  }, [paramSearch]);
  useEffect(() => {
    load_more_contact();
  }, [page]);
  return (
    <>

      <MIconButton
        ref={anchorRef}
        size="large"
        color={open ? 'primary' : 'default'}
        onClick={handleOpen}
        sx={{
          ...(open && {
            bgcolor: (theme) => alpha(theme.palette.primary.main, theme.palette.action.focusOpacity)
          })
        }}
      >
        <Icon icon={peopleFill} width={20} height={20} />
      </MIconButton>

      <MenuPopover open={open} onClose={handleClose} anchorEl={anchorRef.current} sx={{ width: 360, p: 0, overflow: "hidden" }}>
        <Stack direction={'row'} sx={{ display: 'flex', justifyContent: 'end' }} fullWitdh>
          {/* <Typography variant="h6" sx={{ p: PADDING_ITEM }}>
            Liên Hệ <Typography component="span">({contacts?.length})</Typography>
          </Typography> */}
          {/* <ThemeProvider theme={theme}> */}
          <Button onClick={() => handleAddContact()} variant='contained' sx={{ display: "flex", alignItems: "center", height: "32px", p: "20px", mt: '12px', mr: '6px', borderRadius: '8px', color: '#fff', backgroundColor: '#303187' }}  ><Icon icon="mingcute:user-add-fill" width="24px" height="24px" /></Button>
          {/* </ThemeProvider> */}
        </Stack>
        <Stack direction={'row'} sx={{ display: 'flex', justifyContent: 'space-between' }} fullWitdh>
          <SearchStyle
            sx={{ margin: 1, height: 40 }}
            name="text"
            value={paramSearch?.text}
            onChange={handleParamSearch}
            placeholder="Tìm kiếm nhanh..."
            startAdornment={
              <InputAdornment position="start">
                <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
              </InputAdornment>
            }
          />
        </Stack>
        <Box sx={{ height: 512, flexGrow: 1, display: 'flex', overflow: 'hidden' }}>
          <ListQuickContacts
            contacts={contacts}
            loadMoreContacts={loadMoreContacts}
            callContact={callContact}
            page={page}
            endPage={endPage}
          >
          </ListQuickContacts>
        </Box>
        {/* <Scrollbar scrollableNodeProps={{ ref: scrollRef }} sx={{ p: 3, flexGrow: 1, height: ITEM_HEIGHT * 8 }}>
          <Stack spacing={3} sx={{ p: 3 }}>
            {contacts && contacts.map((contact) => {
              const { id, name, avatar, status, phone } = contact;

              return (
                <Stack direction="row" alignItems="center" key={id}>
                  <Avatar src={avatar} sx={{ width: 48, height: 48 }} />
                  <Box sx={{ flexGrow: 1, ml: 2, minWidth: 100 }}>
                    <Typography variant="subtitle2" sx={{ mb: 0.5 }} noWrap>
                      {name}
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
                      {phone}
                    </Typography>
                  </Box>

                  <Tooltip title="Gọi điện">
                    <MIconButton onClick={() => callContact(phone)} size="small">
                      <Icon icon={phoneCallFill} width={22} height={22} />
                    </MIconButton>
                  </Tooltip>
                </Stack>
              );
            })}
          </Stack>
        </Scrollbar> */}
        <Box sx={{ width: "100%" }}>
          <Box sx={{ height: "15px", width: '75%', float: "right", background: "#41c7f5", clipPath: 'polygon(0 0, 100% 0, 100% 100%, 5% 100%)' }}> </Box>
          <Box sx={{ height: "15px", width: '40%', background: "red", clipPath: 'polygon(0 0, 93% 0, 100% 100%, 0 100%)' }}> </Box>
        </Box>
      </MenuPopover>
      {isShowAddContactOnSelect && <FormActionContact2
        infoContact={[]}
        type={'quick_callhistory'}
        participants={[]}
        setIsRefreshContact={setIsRefreshContact}
        isOpen={isShowAddContactOnSelect}
        onClose={handleCloseAddContact}
        onDeleteTask={() => { }}
      />
      }
    </>
  );
}
